import * as TabsPrimitive from "@radix-ui/react-tabs";
import type * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Zakładki przez Radix, a nie własne przyciski ze stanem.
 *
 * Powód jest dostępnościowy i konkretny: Radix daje obsługę strzałek, rolę
 * `tablist`, powiązanie `aria-controls` i zarządzanie fokusem. Ręczna wersja
 * z `aria-pressed` na przyciskach — taka jak była w bibliotece — nie pozwala
 * przechodzić zakładek klawiaturą, co na pilocie oznacza brak dostępu.
 */
export function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col gap-3", className)}
      {...props}
    />
  );
}

export function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "inline-flex w-fit flex-wrap items-center gap-1 rounded-lg bg-muted/60 p-1",
        className,
      )}
      {...props}
    />
  );
}

export function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "focus-ring-own inline-flex items-center justify-center gap-1.5 rounded-md px-3 py-1.5",
        "text-sm font-medium whitespace-nowrap text-muted-foreground transition-colors outline-none",
        "hover:text-foreground",
        "focus-visible:ring-[0.1875rem] focus-visible:ring-ring/60",
        "data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm",
        "disabled:pointer-events-none disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("outline-none", className)}
      {...props}
    />
  );
}
